import Layout from '@/components/feature/Layout';
import HeroBanner from './components/HeroBanner';
import FeaturedAnime from './components/FeaturedAnime';
import LatestAnime from './components/LatestAnime';
import CategoryShowcase from './components/CategoryShowcase';
import ArticleRecommend from './components/ArticleRecommend';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <Layout>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '小樱动漫',
            url: 'https://www.xiaoyinganime.com',
            description: '小樱动漫是专注于正版高清动漫内容的在线观看平台，汇聚海量日漫、国漫、经典动画资源。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://www.xiaoyinganime.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '小樱动漫',
            url: 'https://www.xiaoyinganime.com',
            description: '正版高清动漫在线观看平台',
            sameAs: ['https://weibo.com/xiaoyinganime', 'https://space.bilibili.com/xiaoyinganime'],
          }),
        }}
      />
      <HeroBanner />
      <FeaturedAnime />
      <CategoryShowcase />
      <LatestAnime />
      <ArticleRecommend />
      <CTASection />
    </Layout>
  );
}